import debounce from 'lodash.debounce'
import API from './services/api'

export default class Search {
  constructor() {
    this.modal = document.querySelector('[data-id="modal-search"]')

    if (this.modal) {
      this.input = this.modal.querySelector('input')
      this.clearBtn = this.modal.querySelector('[data-clear]')
      this.counter = this.modal.querySelector('[data-counter]')
      this.results = this.modal.querySelector('main')

      this.input.addEventListener(
        'keyup',
        debounce(this.handleKeyup.bind(this), 300)
      )
      this.clearBtn.addEventListener('click', () => {
        this.reset()
      })
    }
  }

  handleKeyup(event) {
    // Skip search for modifier keys, navigation keys, and function keys
    const skipKeys = [
      'Shift',
      'Control',
      'Alt',
      'Meta',
      'CapsLock',
      'Tab',
      'ArrowUp',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End',
      'PageUp',
      'PageDown',
      'F1',
      'F2',
      'F3',
      'F4',
      'F5',
      'F6',
      'F7',
      'F8',
      'F9',
      'F10',
      'F11',
      'F12',
      'Escape',
      'Insert',
      'Delete',
    ]

    if (skipKeys.includes(event.key)) {
      return
    }

    this.search()
  }

  async search() {
    const value = this.input.value.trim()
    if (value.length < 2) return

    const response = await API.search(
      new URLSearchParams({ query: this.input.value }).toString()
    )

    this.results.innerHTML = response.html
    this.clearBtn.parentNode.classList.add('has-addons')
    this.results.classList.remove('is-hidden')
    this.counter.classList.remove('is-hidden')
    this.counter.querySelector('span').innerHTML = response.count
  }

  reset() {
    this.input.value = ''
    this.input.focus()
    this.results.innerHTML = ''
    this.clearBtn.parentNode.classList.remove('has-addons')
    this.results.classList.add('is-hidden')
    this.counter.classList.add('is-hidden')
  }
}
